import { PRODUCT_MENU_FEATURES, resolveZooProductScope } from "../product-access/productScope";
import { canOpenProductLocation } from "../product-access/productRoutePolicy";
// Configuration des menus selon les tiers de zoo et les rôles d'utilisateur

import { canAccessVetModule } from "../utils/notes/noteVisibility";
import { canAccessTechnicalModule } from "../utils/technical/technicalAccess";
import { isZooFeatureEnabled } from "../utils/zooFeatureFlags";
import { isGridManagementTierAllowed } from "../utils/gridAccess";
import { isResearchGuestProfile, RESEARCH_GUEST } from "../utils/users/researchGuest";

const MENU_ITEMS = {
  // Rafiki Assistant (page complète) - réservé aux membres Akongo ; entrée de menu désactivée
  RAFIKI_FULL: {
    name: "Rafiki Assistant",
    icon: "fa fa-robot",
    path: "RafikiFullView",
    translate: "sidebar.nav.RAFIKI_FULL",
  },
  // Items de base disponibles pour tous
  DASHBOARD: {
    name: "Centre de pilotage",
    icon: "fa fa-tachometer-alt",
    path: "DashboardNext",
    translate: "sidebar.nav.DASHBOARD",
  },
  MY_REMINDERS: {
    name: "Mes rappels",
    icon: "fa fa-stopwatch",
    path: "MyActivitiesView",
    translate: "sidebar.nav.MY_REMINDERS",
  },
  TASK_MANAGEMENT: {
    name: "Gestion des tâches",
    icon: "fa fa-tasks",
    path: "TaskManagementView",
    translate: "sidebar.nav.TASK_MANAGEMENT",
  },
  GAMIFICATION: {
    name: "Engagement des soigneurs",
    icon: "fa fa-trophy",
    path: "EngagementView",
    translate: "sidebar.nav.GAMIFICATION",
  },
  LIVE_VIEW: {
    name: "Vue Live",
    icon: "fa fa-broadcast-tower",
    path: "LiveSectorView",
    translate: "sidebar.nav.LIVE_VIEW",
  },

  // Données BEA
  CAMPAIGN_MANAGEMENT: {
    name: "Gestion des campagnes",
    icon: "fa fa-bullhorn",
    path: "CampaignListView",
    translate: "sidebar.nav.CAMPAIGN_MANAGEMENT",
  },
  HISTORY: {
    name: "Historique collectes",
    icon: "fa fa-history",
    path: "EvalHistory",
    translate: "sidebar.nav.HISTORY",
  },
  FAST_EVALUATION: {
    name: "Grilles d'évaluation",
    icon: "fa fa-bolt",
    path: "FastEvalGroupListView",
    translate: "sidebar.nav.FAST_EVALUATION",
  },
  INDIVIDUAL_FAST_EVALUATION: {
    name: "Évaluations individuelles",
    icon: "fa fa-paw",
    path: "IndividualFastEvalListView",
    translate: "sidebar.nav.INDIVIDUAL_FAST_EVALUATION",
  },
  GRID_MANAGEMENT: {
    name: "Mes grilles",
    icon: "fa fa-th",
    path: "GridManagementView",
    translate: "sidebar.nav.GRID_MANAGEMENT",
  },
  TIMELINE: {
    name: "Timeline",
    icon: "fa fa-stream",
    path: "Timeline",
    translate: "sidebar.nav.TIMELINE",
  },
  EVALUATION_MONITORING: {
    name: "Consulter les données collectées",
    icon: "fa fa-clipboard-check",
    path: "CampaignQuizzMonitoringView",
    translate: "sidebar.nav.EVALUATION_MONITORING",
  },
  BILAN: {
    name: "Bilan d'Activité",
    icon: "fa fa-chart-line",
    path: "cirManagementView",
    translate: "sidebar.nav.BILAN",
  },
  
  // Gestion du parc
  SECTOR_MANAGEMENT: {
    name: "Gestion des secteurs",
    icon: "fa fa-map-marked-alt",
    path: "SectorListView",
    translate: "sidebar.nav.SECTOR_MANAGEMENT",
  },
  TOURNEE_MANAGEMENT: {
    name: "Gestion des tournées",
    icon: "fa fa-route",
    path: "TourneeListView",
    translate: "sidebar.nav.TOURNEE_MANAGEMENT",
  },
  DAILY_REPORTS: {
    name: "Rapports journaliers",
    icon: "fa fa-clipboard-list",
    path: "DailyReportsView",
    translate: "sidebar.nav.DAILY_REPORTS",
  },
  ANIMAL_MANAGEMENT: {
    name: "Gestion des individus",
    icon: "fa fa-paw",
    path: "specieAnimalsListView",
    translate: "sidebar.nav.ANIMAL_MANAGEMENT",
  },
  GROUP_MANAGEMENT: {
    name: "Gestion des groupes",
    icon: "fa fa-users",
    path: "FastGroupManagementListView",
    translate: "sidebar.nav.GROUP_MANAGEMENT",
  },
  OBJECTIVES_MANAGEMENT: {
    name: "Gestion des objectifs",
    icon: "fa fa-bullseye",
    path: "ObjectivesListView",
    translate: "sidebar.nav.OBJECTIVES_MANAGEMENT",
  },
  GROUP_MANAGEMENT_OLD: {
    name: "Gestion des groupes (old)",
    icon: "fa fa-layer-group",
    path: "GroupListView",
    translate: "sidebar.nav.GROUP_MANAGEMENT_OLD",
  },
  ENCLOSURE_MANAGEMENT: {
    name: "Gestion des enclos",
    icon: "fa fa-th-large",
    path: "EnclosureListView",
    translate: "sidebar.nav.ENCLOSURE_MANAGEMENT",
  },
  ENRICHMENT_MANAGEMENT: {
    name: "Gestion des enrichissements",
    icon: "fa fa-gift",
    path: "EnrichListView",
    translate: "sidebar.nav.ENRICHMENT_MANAGEMENT",
  },
  ENRICHMENT_GUIDES: {
    name: "Guides d'enrichissement",
    // fa-tools n'existe pas en Font Awesome 5.5.0 (ajouté en 5.7)
    icon: "fa fa-book-open",
    path: "EnrichmentGuidesView",
    translate: "sidebar.nav.ENRICHMENT_GUIDES",
  },
  // La section vétérinaire est une SECTION dépliée (heading + 3 items) construite dans
  // buildMenu (VETERINARY_SECTION_ITEMS), pas un item plat. Cette clé reste pour le
  // repli/legacy éventuel et pointe le groupe clinique par défaut.
  VETERINARY_DASHBOARD: {
    name: "Vétérinaire",
    icon: "fa fa-stethoscope",
    path: "VeterinaryDashboardView/clinical",
    translate: "sidebar.nav.VETERINARY_DASHBOARD",
  },
  // Module Technique & Maintenance. Comme le vétérinaire, c'est une SECTION dépliée
  // construite dans buildMenu ; en phase 1 elle n'a qu'un groupe (« Interventions »),
  // les groupes Patrimoine et Référentiel arrivent en phases 2 et 4.
  // Cf. docs/decisions/2026-08-07-module-technique-maintenance.md
  TECHNICAL_DASHBOARD: {
    name: "Technique",
    icon: "fa fa-wrench",
    path: "TechnicalDashboardView/operations",
    translate: "sidebar.nav.TECHNICAL_DASHBOARD",
  },
  CUSTOM_PARAMETERS_HUB: {
    name: "Paramètres personnalisés",
    icon: "fa fa-sliders-h",
    path: "CustomParametersHubView",
    translate: "sidebar.nav.CUSTOM_PARAMETERS_HUB",
  },

  // Ressources (read-only)
  QUIZZ_MONITORING: {
    name: "Questionnaires",
    icon: "fa fa-question-circle",
    path: "QuizzListViewReadOnly",
    translate: "sidebar.nav.QUIZZ_MONITORING",
  },
  ETHO_MONITORING: {
    name: "Consulter les éthogrammes",
    icon: "fa fa-list",
    path: "obsListViewReadOnly",
    translate: "sidebar.nav.ETHO_MONITORING",
  },
  OBS_TRAINING: {
    name: "Entraînement observateurs",
    icon: "fa fa-binoculars",
    path: "ObsTrainingListView",
    translate: "sidebar.nav.OBS_TRAINING",
  },
  // Grille d'évaluation rapide vierge (retour 8, GitLab #1196) : tout parc, Discovery compris.
  BLANK_GRID: {
    name: "Grille d'évaluation vierge",
    icon: "fa fa-clipboard-list",
    path: "BlankGridView",
    translate: "sidebar.nav.BLANK_GRID",
  },

  // Data analyse
  FOCAL_SAMPLING: {
    name: "Analyse Focal Sampling",
    icon: "fa fa-chart-line",
    path: "FocalSamplingListView",
    translate: "sidebar.nav.FOCAL_SAMPLING",
  },
  ENRICHMENT_ANALYSIS: {
    name: "Analyse Enrichissements",
    icon: "fa fa-chart-pie",
    path: "EnrichmentAnalysisListView",
    translate: "sidebar.nav.ENRICHMENT_ANALYSIS",
  },
  SCAN_ANALYSIS: {
    name: "Analyse Scan Sampling",
    icon: "fa fa-map",
    path: "ScanAnalysisListView",
    translate: "sidebar.nav.SCAN_ANALYSIS",
  },
  QUIZZ_ANALYSIS: {
    name: "Analyse Questionnaires",
    icon: "fa fa-clipboard-check",
    path: "QuizzAnalysisListView",
    translate: "sidebar.nav.QUIZZ_ANALYSIS",
  },
  MULTI_PARAMETER_ANALYSIS: {
    name: "Analyse Multi-Paramètres",
    icon: "fa fa-chart-area",
    path: "MultiParameterAnalysisView",
    translate: "sidebar.nav.MULTI_PARAMETER_ANALYSIS",
  },
  WEIGHT_ANALYSIS: {
    name: "Analyse de poids",
    icon: "fa fa-weight",
    path: "WeightAnalysisView",
    translate: "sidebar.nav.WEIGHT_ANALYSIS",
  },
  // Gestion compte
  USER_SETTINGS: {
    name: "Gérer mon compte",
    icon: "fa fa-user-circle",
    path: "userSettings",
    translate: "sidebar.nav.USER_SETTINGS",
  },
  ZOO_MANAGEMENT: {
    name: "Gérer mon établissement",
    icon: "fa fa-building",
    path: "zooDetails",
    translate: "sidebar.nav.ZOO_MANAGEMENT",
  },
  USER_CREATION: {
    name: "Inviter des utilisateurs",
    icon: "fa fa-user-plus",
    path: "userCreation",
    translate: "sidebar.nav.USER_CREATION",
  },

  // Premium features
  REPORT_MANAGEMENT: {
    name: "Rapports avancés",
    icon: "fa fa-file-alt",
    path: "ReportListView",
    translate: "sidebar.nav.REPORT",
  },
  ANALYTICS: {
    name: "Analytics",
    icon: "fa fa-chart-pie",
    path: "AnalyticsView",
    translate: "sidebar.nav.ANALYTICS",
  },
  
  // Enterprise features
  MULTI_ZOO: {
    name: "Gestion multi-établissements",
    icon: "fa fa-network-wired",
    path: "MultiZooView",
    translate: "sidebar.nav.MULTI_ZOO",
  },
  API_ACCESS: {
    name: "Accès API",
    icon: "fa fa-code",
    path: "ApiAccessView",
    translate: "sidebar.nav.API_ACCESS",
  },
  
  // Help Center - Documentation, accessible à tous les utilisateurs
  HELP_CENTER: {
    name: "Documentation",
    icon: "fa fa-book",
    path: "HelpCenterView",
    translate: "sidebar.nav.HELP_CENTER",
  },
  SUPPORT_TICKETS: {
    name: "Tickets d'assistance",
    icon: "fa fa-headset",
    path: "SupportTicketsView",
    translate: "sidebar.nav.SUPPORT_TICKETS",
  },

  // Admin tickets (Akongo staff only)
  ADMIN_TICKETS: {
    name: "Tickets d'assistance",
    icon: "fa fa-headset",
    path: "AdminTicketsView",
    translate: "sidebar.nav.ADMIN_TICKETS",
  },

  // SuperAdmin only
  ESTABLISHMENT_MANAGEMENT: {
    name: "Gestion des établissements",
    icon: "fa fa-building",
    path: "ZooList",
    translate: "sidebar.nav.ESTABLISHMENT_MANAGEMENT",
  },
  // Passage des parcs historiques aux offres actuelles (outil staff AKONGO)
  OFFER_MIGRATION: {
    name: "Migration vers les offres",
    icon: "fa fa-exchange-alt",
    path: "OfferMigrationView",
    translate: "sidebar.nav.OFFER_MIGRATION",
  },
  ADMIN_SETTINGS: {
    name: "Réglages Admin",
    icon: "fa fa-sliders-h",
    path: "AdminSettings",
    translate: "sidebar.nav.ADMIN_SETTINGS",
  },
  DISCOVERY_ANALYTICS: {
    name: "Discovery Analytics",
    icon: "fa fa-chart-line",
    path: "DiscoveryAnalytics",
    translate: "sidebar.nav.DISCOVERY_ANALYTICS",
  },
  PAID_ACCOUNTS_ANALYTICS: {
    name: "Paid Accounts Analytics",
    icon: "fa fa-chart-bar",
    path: "PaidAccountsAnalytics",
    translate: "sidebar.nav.PAID_ACCOUNTS_ANALYTICS",
  },
  PUBLIC_API_ANALYTICS: {
    name: "API Publique Analytics",
    icon: "fa fa-satellite-dish",
    path: "PublicApiAnalytics",
    translate: "sidebar.nav.PUBLIC_API_ANALYTICS",
  },
  ZIMS_SYNC_DASHBOARD: {
    name: "ZIMS Sync Dashboard",
    icon: "fa fa-sync-alt",
    path: "ZimsSyncDashboard",
    translate: "sidebar.nav.ZIMS_SYNC_DASHBOARD",
  },
  ZIMS_COLLECTION: {
    name: "Collection ZIMS",
    icon: "fa fa-globe",
    path: "ZimsCollection",
    translate: "sidebar.nav.ZIMS_COLLECTION",
  },
  WEATHER: {
    name: "Météo",
    icon: "fa fa-cloud-sun",
    path: "WeatherView",
    translate: "sidebar.nav.WEATHER",
  },
  TRAINING_EXERCISES: {
    name: "Référentiel training",
    icon: "fa fa-graduation-cap",
    path: "TrainingExercisesView",
    translate: "sidebar.nav.TRAINING_EXERCISES",
  },
  TRAINING_DASHBOARD: {
    name: "Analyse training",
    icon: "fa fa-chart-line",
    path: "TrainingDashboardView",
    translate: "sidebar.nav.TRAINING_DASHBOARD",
  },
  RESEARCH_PROJECTS: {
    name: "Projets de recherche",
    icon: "fa fa-flask",
    path: "ResearchListView",
    translate: "sidebar.nav.PROJECT_MANAGEMENT",
  },
  TIME_TRACKING: {
    name: "Suivi de temps",
    icon: "fa fa-stopwatch",
    path: "TimeTrackingView",
    translate: "sidebar.nav.TIME_TRACKING",
  },
  AKONGO_PROJECTS: {
    name: "Projets AKONGO",
    icon: "fa fa-folder-open",
    path: "AkongoProjectsView",
    translate: "sidebar.nav.AKONGO_PROJECTS",
  },
  BIBLIOGRAPHY: {
    name: "Biblio",
    icon: "fa fa-book-open",
    path: "BibliographyView",
    translate: "sidebar.nav.BIBLIOGRAPHY",
  },
  QUESTIONNAIRE_ADMIN: {
    name: "Gestion des questionnaires",
    icon: "fa fa-list-alt",
    translate: "sidebar.nav.GESTION_QUESTIONNAIRES",
    submenu: [
      {
        name: "Gestion des Questionnaires",
        translate: "sidebar.nav.GESTION_QUESTIONNAIRES_VIEW",
        path: "quizzListView3",
      },
      {
        name: "Gestion Questions",
        translate: "sidebar.nav.GESTION_QUESTIONS_VIEW",
        path: "QuestionListView",
      },
      {
        name: "Gestion Profils",
        translate: "sidebar.nav.GESTION_PROFILS_VIEW",
        path: "QuizzProfileView",
      },
    ],
  },
  OBSERVATION_ADMIN: {
    name: "Gestion des observations",
    icon: "fa fa-binoculars",
    translate: "sidebar.nav.OBSERVATION_MANAGEMENT",
    submenu: [
      {
        name: "Ethogrammes",
        translate: "sidebar.nav.ETHOGRAMME",
        path: "ObsListView",
      },
      {
        name: "Contextes",
        translate: "sidebar.nav.CONTEXTE",
        path: "ObsContextListView",
      },
    ],
  },
  TAXON_MANAGEMENT: {
    name: "Gestion des taxons",
    icon: "fa fa-dna",
    translate: "sidebar.nav.TAXON_MANAGEMENT",
    submenu: [
      {
        name: "Base ordres",
        path: "/OrderListManagement",
        translate: "sidebar.nav.ORDER_MANAGEMENT",
      },
      {
        name: "Base familles",
        path: "/FamilyListManagement",
        translate: "sidebar.nav.FAMILY_MANAGEMENT",
      },
      {
        name: "Base espèces",
        path: "/SpecieListManagement",
        translate: "sidebar.nav.ESPECE_MANAGEMENT",
      },
      {
        name: "Recherche IUCN",
        path: "/IUCNSpeciesSearch",
        translate: "sidebar.nav.IUCN_SPECIES_SEARCH",
      },
      ...(process.env.NODE_ENV === "development" ? [{
        name: "Debug & Maintenance",
        path: "/DebugView",
        translate: "sidebar.nav.DEBUG_MAINTENANCE",
      }] : []),
    ],
  },
  AWM_SETTINGS: {
    name: "Paramétrage AWM",
    icon: "fa fa-cog",
    translate: "sidebar.nav.AWM_SETTINGS",
    submenu: [
      {
        name: "Tags d'enrichissement",
        translate: "sidebar.nav.TAG_MANAGEMENT_GLOBAL",
        path: "TagManagementView",
      },
      {
        name: "Tags des documents",
        translate: "sidebar.nav.DOCUMENT_TAGS_MANAGEMENT",
        path: "DocumentTagsManagementView",
      },
    ],
  },
  // Debug tools (Akongo staff only)
  RAFIKI_TRANSLATION_DEBUG: {
    name: "Rafiki Translation Debug",
    icon: "fa fa-language",
    path: "RafikiTranslationDebug",
    translate: "sidebar.nav.RAFIKI_TRANSLATION_DEBUG",
  },
  ETHOGRAM_TRANSLATION_DEBUG: {
    name: "Ethogram Translation Debug",
    icon: "fa fa-language",
    path: "EthogramTranslationDebug",
    translate: "sidebar.nav.ETHOGRAM_TRANSLATION_DEBUG",
  },
  CONTEXT_TRANSLATION_DEBUG: {
    name: "Context Translation Debug",
    icon: "fa fa-language",
    path: "ContextTranslationDebug",
    translate: "sidebar.nav.CONTEXT_TRANSLATION_DEBUG",
  },
  DEEPL_STATS: {
    name: "DeepL Analytics",
    icon: "fa fa-chart-pie",
    path: "DeeplStats",
    translate: "sidebar.nav.DEEPL_STATS",
  },
  TRANSLATION_CACHE_ADMIN: {
    name: "Traductions & cache",
    icon: "fa fa-language",
    path: "TranslationCacheAdminView",
    translate: "sidebar.nav.TRANSLATION_CACHE_ADMIN",
  },
  RAFIKI_STATS: {
    name: "Rafiki Analytics",
    icon: "fa fa-robot",
    path: "RafikiStats",
    translate: "sidebar.nav.RAFIKI_STATS",
  },
};

// Configuration des niveaux de service (followUpLevel)
const ZOO_TIERS = {
  discovery: {
    name: "Discovery",
    features: [
      // Niveau découverte - Fast Evaluation + Objectifs
      "FAST_EVALUATION",
      "INDIVIDUAL_FAST_EVALUATION",
      "OBJECTIVES_MANAGEMENT",
      "OBS_TRAINING",
      "USER_SETTINGS",
      "SUPPORT_TICKETS",
    ],
  },
  essential: {
    name: "Essential",
    features: [
      // Niveau essentiel - toutes les fonctionnalités de base
      "DASHBOARD",
      "TASK_MANAGEMENT",
      "LIVE_VIEW",
      "CAMPAIGN_MANAGEMENT",
      "HISTORY",
      "FAST_EVALUATION",
      "INDIVIDUAL_FAST_EVALUATION",
      "TIMELINE",
      "EVALUATION_MONITORING",
      "BILAN",
      "SECTOR_MANAGEMENT",
      "TOURNEE_MANAGEMENT",
      "DAILY_REPORTS",
      "ANIMAL_MANAGEMENT",
      "GROUP_MANAGEMENT",
      "OBJECTIVES_MANAGEMENT",
      "ENCLOSURE_MANAGEMENT",
      "ZIMS_COLLECTION",
      "WEATHER",
      "TRAINING_EXERCISES",
      "TRAINING_DASHBOARD",
      "QUIZZ_MONITORING",
      "ETHO_MONITORING",
      "FOCAL_SAMPLING", // Data analyse
      "SCAN_ANALYSIS",
      "QUIZZ_ANALYSIS",
      "MULTI_PARAMETER_ANALYSIS",
      "WEIGHT_ANALYSIS",
      "OBS_TRAINING",
      "USER_SETTINGS",
      "ZOO_MANAGEMENT",
      "USER_CREATION",
      "REPORT_MANAGEMENT",
      "ANALYTICS",
      "SUPPORT_TICKETS",
    ],
  },
  progress: {
    name: "Progress",
    features: [
      // Niveau progression - identique à Essential
      "DASHBOARD",
      "TASK_MANAGEMENT",
      "LIVE_VIEW",
      "CAMPAIGN_MANAGEMENT",
      "HISTORY",
      "FAST_EVALUATION",
      "INDIVIDUAL_FAST_EVALUATION",
      "TIMELINE",
      "EVALUATION_MONITORING",
      "BILAN",
      "SECTOR_MANAGEMENT",
      "TOURNEE_MANAGEMENT",
      "DAILY_REPORTS",
      "ANIMAL_MANAGEMENT",
      "GROUP_MANAGEMENT",
      "OBJECTIVES_MANAGEMENT",
      "ENCLOSURE_MANAGEMENT",
      "ZIMS_COLLECTION",
      "WEATHER",
      "TRAINING_EXERCISES",
      "TRAINING_DASHBOARD",
      "QUIZZ_MONITORING",
      "ETHO_MONITORING",
      "FOCAL_SAMPLING", // Data analyse
      "SCAN_ANALYSIS",
      "QUIZZ_ANALYSIS",
      "MULTI_PARAMETER_ANALYSIS",
      "WEIGHT_ANALYSIS",
      "OBS_TRAINING",
      "USER_SETTINGS",
      "ZOO_MANAGEMENT",
      "USER_CREATION",
      "REPORT_MANAGEMENT",
      "ANALYTICS",
      "SUPPORT_TICKETS",
    ],
  },
  fullcare: {
    name: "Full Care",
    features: [
      // Niveau complet - Essential/Progress + Enrichissements + Projets de recherche
      "DASHBOARD",
      "TASK_MANAGEMENT",
      "LIVE_VIEW",
      "CAMPAIGN_MANAGEMENT",
      "HISTORY",
      "FAST_EVALUATION",
      "INDIVIDUAL_FAST_EVALUATION",
      "TIMELINE",
      "EVALUATION_MONITORING",
      "BILAN",
      "SECTOR_MANAGEMENT",
      "TOURNEE_MANAGEMENT",
      "DAILY_REPORTS",
      "ANIMAL_MANAGEMENT",
      "GROUP_MANAGEMENT",
      "OBJECTIVES_MANAGEMENT",
      "ENCLOSURE_MANAGEMENT",
      "ZIMS_COLLECTION",
      "WEATHER",
      "TRAINING_EXERCISES",
      "TRAINING_DASHBOARD",
      "ENRICHMENT_MANAGEMENT", // Ajouté pour Full Care
      "ENRICHMENT_GUIDES", // Guides de fabrication communautaires (feature flag)
      "VETERINARY_DASHBOARD", // Dashboard vétérinaire
      "TECHNICAL_DASHBOARD", // Module Technique & Maintenance
      "CUSTOM_PARAMETERS_HUB", // Hub paramètres personnalisés
      "QUIZZ_MONITORING",
      "ETHO_MONITORING",
      "FOCAL_SAMPLING", // Data analyse
      "ENRICHMENT_ANALYSIS",
      "SCAN_ANALYSIS",
      "QUIZZ_ANALYSIS",
      "MULTI_PARAMETER_ANALYSIS",
      "WEIGHT_ANALYSIS",
      "OBS_TRAINING",
      "USER_SETTINGS",
      "ZOO_MANAGEMENT",
      "USER_CREATION",
      "REPORT_MANAGEMENT",
      "ANALYTICS",
      "RESEARCH_PROJECTS", // Ajouté pour Full Care
      "SUPPORT_TICKETS",
    ],
  },
  research_partner: {
    name: "Research Partner",
    features: [
      // Partenaire de recherche - identique à Full Care + Dashboard vétérinaire
      "DASHBOARD",
      "TASK_MANAGEMENT",
      "LIVE_VIEW",
      "CAMPAIGN_MANAGEMENT",
      "HISTORY",
      "FAST_EVALUATION",
      "INDIVIDUAL_FAST_EVALUATION",
      "TIMELINE",
      "EVALUATION_MONITORING",
      "BILAN",
      "SECTOR_MANAGEMENT",
      "TOURNEE_MANAGEMENT",
      "DAILY_REPORTS",
      "ANIMAL_MANAGEMENT",
      "GROUP_MANAGEMENT",
      "OBJECTIVES_MANAGEMENT",
      "ENCLOSURE_MANAGEMENT",
      "ZIMS_COLLECTION",
      "WEATHER",
      "TRAINING_EXERCISES",
      "TRAINING_DASHBOARD",
      "ENRICHMENT_MANAGEMENT",
      "ENRICHMENT_GUIDES", // Guides de fabrication communautaires (feature flag)
      "VETERINARY_DASHBOARD", // Dashboard vétérinaire
      "TECHNICAL_DASHBOARD", // Module Technique & Maintenance
      "CUSTOM_PARAMETERS_HUB", // Hub paramètres personnalisés
      "QUIZZ_MONITORING",
      "ETHO_MONITORING",
      "FOCAL_SAMPLING", // Data analyse
      "ENRICHMENT_ANALYSIS",
      "SCAN_ANALYSIS",
      "QUIZZ_ANALYSIS",
      "MULTI_PARAMETER_ANALYSIS",
      "WEIGHT_ANALYSIS",
      "OBS_TRAINING",
      "USER_SETTINGS",
      "ZOO_MANAGEMENT",
      "USER_CREATION",
      "REPORT_MANAGEMENT",
      "ANALYTICS",
      "RESEARCH_PROJECTS",
      "SUPPORT_TICKETS",
    ],
  },
  // Configuration spéciale Akongo pour les super admins
  akongo: {
    name: "Akongo",
    features: [
      // Toutes les fonctionnalités possibles
      "DASHBOARD",
      "TASK_MANAGEMENT",
      "LIVE_VIEW",
      "CAMPAIGN_MANAGEMENT",
      "HISTORY",
      "FAST_EVALUATION",
      "INDIVIDUAL_FAST_EVALUATION",
      "GRID_MANAGEMENT",
      "TIMELINE",
      "EVALUATION_MONITORING",
      "BILAN",
      "SECTOR_MANAGEMENT",
      "TOURNEE_MANAGEMENT",
      "DAILY_REPORTS",
      "ANIMAL_MANAGEMENT",
      "GROUP_MANAGEMENT", // Nouvelle gestion des groupes
      "OBJECTIVES_MANAGEMENT",
      "ENCLOSURE_MANAGEMENT",
      "ZIMS_COLLECTION",
      "WEATHER",
      "TRAINING_EXERCISES",
      "TRAINING_DASHBOARD",
      "ENRICHMENT_MANAGEMENT",
      "ENRICHMENT_GUIDES", // Guides de fabrication communautaires (feature flag)
      "VETERINARY_DASHBOARD", // Dashboard vétérinaire
      "TECHNICAL_DASHBOARD", // Module Technique & Maintenance
      "CUSTOM_PARAMETERS_HUB", // Hub paramètres personnalisés
      "QUIZZ_MONITORING",
      "ETHO_MONITORING",
      "FOCAL_SAMPLING",
      "ENRICHMENT_ANALYSIS",
      "SCAN_ANALYSIS",
      "QUIZZ_ANALYSIS",
      "MULTI_PARAMETER_ANALYSIS",
      "WEIGHT_ANALYSIS",
      "OBS_TRAINING",
      "USER_SETTINGS",
      "ZOO_MANAGEMENT",
      "USER_CREATION",
      "REPORT_MANAGEMENT",
      "ANALYTICS",
      "MULTI_ZOO",
      "API_ACCESS",
      "ESTABLISHMENT_MANAGEMENT",
      "OFFER_MIGRATION",
      "ADMIN_SETTINGS",
      "DISCOVERY_ANALYTICS",
      "PAID_ACCOUNTS_ANALYTICS",
      "PUBLIC_API_ANALYTICS",
      "ZIMS_SYNC_DASHBOARD",
      "RESEARCH_PROJECTS",
      "QUESTIONNAIRE_ADMIN",
      "OBSERVATION_ADMIN",
      "TAXON_MANAGEMENT",
      "AWM_SETTINGS",
      // Debug tools retirés du menu mais gardés dans le codebase
      // "RAFIKI_TRANSLATION_DEBUG",
      // "ETHOGRAM_TRANSLATION_DEBUG",
      // "CONTEXT_TRANSLATION_DEBUG",
      "DEEPL_STATS",
      "RAFIKI_STATS",
      "HELP_CENTER",
      "SUPPORT_TICKETS",
    ],
  },
};

// Restrictions selon le rôle
const ROLE_RESTRICTIONS = {
  user: {
    // Les utilisateurs normaux n'ont pas accès à ces fonctionnalités
    restricted: [
      "ZIMS_COLLECTION",
      "WEATHER",
      "TRAINING_EXERCISES",
      "TRAINING_DASHBOARD",
      "ZOO_MANAGEMENT",
      "USER_CREATION",
      "ESTABLISHMENT_MANAGEMENT",
      "ADMIN_SETTINGS",
      "RESEARCH_PROJECTS",
      "QUESTIONNAIRE_ADMIN",
      "OBSERVATION_ADMIN",
      "TAXON_MANAGEMENT",
      "AWM_SETTINGS",
      "API_ACCESS",
      "MULTI_ZOO",
    ],
  },
  pedagoadmin: {
    // Mode pédagogique - accès très limité
    allowed: [
      "DASHBOARD",
      "QUIZZ_MONITORING",
      "ETHO_MONITORING",
      // Entraînement observateurs : participer et voir ses résultats (contrat v2, section G)
      "OBS_TRAINING",
      "USER_SETTINGS",
    ],
  },
  // Invité recherche, sans parc (invites-exterieurs.md D5) : en Classique,
  // l'aide et son compte seulement ; ses projets n'existent qu'en V2, où il
  // est toujours envoyé (legacyAccessAdapter, DefaultRedirect).
  researchGuest: {
    allowed: [
      "HELP_CENTER",
      "USER_SETTINGS",
    ],
  },
  admin: {
    // Les admins ont accès à tout sauf les fonctionnalités superAdmin
    restricted: [
      "ESTABLISHMENT_MANAGEMENT",
      "ADMIN_SETTINGS",
      "RESEARCH_PROJECTS",
      "QUESTIONNAIRE_ADMIN",
      "OBSERVATION_ADMIN",
      "TAXON_MANAGEMENT",
      "AWM_SETTINGS",
    ],
  },
  superAdmin: {
    // Accès complet
    restricted: [],
  },
};

// Fonction pour générer le menu selon le niveau de service (tier) et le rôle
export function generateMenu(zooTier = 'essential', userRole = 'user', zooOptions = {}, authenticatedUserData) {
  console.log('MenuConfig.generateMenu called with tier:', zooTier, 'role:', userRole);
  
  // Mapper les valeurs legacy
  if (zooTier === 'basic') {
    console.log('MenuConfig: Mapping basic to essential');
    zooTier = 'essential';
  }
  
  // Vérifier si l'utilisateur est membre Akongo
  let parsedUserData = {};
  if (arguments.length >= 4) {
    parsedUserData = authenticatedUserData && typeof authenticatedUserData === 'object'
      ? authenticatedUserData
      : {};
  } else {
    try {
      const userData = localStorage.getItem('userData');
      parsedUserData = userData ? JSON.parse(userData) : {};
    } catch (_) {
      parsedUserData = {};
    }
  }
  const isAkongoMember = parsedUserData.akongoStaff === true || parsedUserData.akongoRank === 'board';
  const currentZooId = parsedUserData.zooId;

  // Invité recherche : aucun parc, donc ni rappels, ni grille, ni outil de parc.
  if ((userRole === RESEARCH_GUEST || isResearchGuestProfile(parsedUserData)) && parsedUserData.akongoStaff !== true) {
    const allowed = ROLE_RESTRICTIONS.researchGuest.allowed;
    return [
      ...(allowed.includes('HELP_CENTER') ? [{ heading: "Assistance", translate: "sidebar.heading.ASSISTANCE" }, MENU_ITEMS.HELP_CENTER] : []),
      ...(allowed.includes('USER_SETTINGS') ? [{ heading: "Mon compte AWM", translate: "sidebar.heading.MY_ACCOUNT" }, MENU_ITEMS.USER_SETTINGS] : []),
    ];
  }

  // Le menu s'adapte au tier du zoo actuel
  // Les membres Akongo voient le menu du tier + les outils d'admin Akongo en dessous
  // Seule exception : sur le zoo Akongo, les superAdmin/membres ont accès complet
  if (currentZooId === 'akongo' && (userRole === 'superAdmin' || isAkongoMember)) {
    console.log('MenuConfig: On Akongo zoo, using akongo tier for full admin access');
    zooTier = 'akongo';
  } else {
    console.log('MenuConfig: Respecting zoo tier:', zooTier, 'for user role:', userRole);
    // Garder le tier du zoo (discovery, essential, progress, fullcare, research_partner)
  }
  
  const tierConfig = ZOO_TIERS[zooTier] || ZOO_TIERS.essential;
  const roleConfig = ROLE_RESTRICTIONS[userRole] || ROLE_RESTRICTIONS.user;
  
  console.log('MenuConfig: Using tier config:', tierConfig.name, 'with', tierConfig.features.length, 'features');
  console.log('MenuConfig: Features for this tier:', tierConfig.features);
  
  const menu = [];
  const addedSections = new Set();
  let hasMainSectionItems = false; // Pour vérifier si on a des items dans la section principale
  
  // Helper pour ajouter une section
  const addSection = (heading, translateKey) => {
    if (!addedSections.has(heading)) {
      menu.push({
        heading: heading,
        translate: translateKey,
      });
      addedSections.add(heading);
    }
  };
  
  // Outils réservés à la section Administration AWM (ne pas afficher dans les sections normales)
  const akongoAdminOnlyTools = [
    'ESTABLISHMENT_MANAGEMENT',
    'OFFER_MIGRATION',
    'ADMIN_SETTINGS',
    'DISCOVERY_ANALYTICS',
    'PAID_ACCOUNTS_ANALYTICS',
    'PUBLIC_API_ANALYTICS',
    'ZIMS_SYNC_DASHBOARD',
    'RESEARCH_PROJECTS',
    'QUESTIONNAIRE_ADMIN',
    'OBSERVATION_ADMIN',
    'TAXON_MANAGEMENT',
    'AWM_SETTINGS',
    'ENRICHMENT_ANALYSIS',
    'SCAN_ANALYSIS',
    'DEEPL_STATS',
    'RAFIKI_STATS',
    'ADMIN_TICKETS',
    'TRANSLATION_CACHE_ADMIN',
    'TIME_TRACKING',
    'AKONGO_PROJECTS',
    'BIBLIOGRAPHY'
  ];

  // Fonction pour vérifier si un item est autorisé (pour les sections normales du menu)
  const productScope = resolveZooProductScope(zooOptions, parsedUserData.userId || parsedUserData.uid);
  // Sans composition, la politique produit ne s'applique qu'aux entrées qu'elle refuse
  // (réglage Rafiki explicite) ; l'ancien tier et les flags gardent la main sur le reste.
  const hasProductPolicy = (key) => Object.prototype.hasOwnProperty.call(PRODUCT_MENU_FEATURES, key)
    && (productScope.mode !== "legacy" || !productScope.allows(PRODUCT_MENU_FEATURES[key]));
  const isAllowed = (itemKey) => {
    if (hasProductPolicy(itemKey) && !productScope.allows(PRODUCT_MENU_FEATURES[itemKey])) return false;
    // Les outils admin Akongo ne doivent PAS apparaître dans les sections normales
    // Ils seront ajoutés dans la section "Administration AWM" séparément
    if (akongoAdminOnlyTools.includes(itemKey) && !hasProductPolicy(itemKey) && !tierConfig.features.includes(itemKey)) {
      return false;
    }

    // Tournées : nécessite activation explicite sur le zoo
    if (itemKey === 'TOURNEE_MANAGEMENT' && !zooOptions.tourneeEnabled) {
      return false;
    }

    // Collection ZIMS : alimentée par la synchro de collection (toggle dédié
    // dans ZooDetails, distinct du master ZIMS sync) ou par un fichier exporté
    // de ZIMS (offre « Import ZIMS ») — même page, même traitement.
    if (itemKey === 'ZIMS_COLLECTION' && !zooOptions.zimsSyncConfig?.collectionSyncEnabled && !productScope.can('zims.import')) {
      return false;
    }

    // Évaluations rapides individuelles : feature flag par zoo (fail-closed),
    // miroir du gate backend isIndividualFastEvalEnabled.
    if (itemKey === 'INDIVIDUAL_FAST_EVALUATION' && !isZooFeatureEnabled(zooOptions, 'individualFastEval')) {
      return false;
    }

    // Guides de fabrication d'enrichissements : feature flag par zoo (fail-closed)
    if (itemKey === 'ENRICHMENT_GUIDES' && !isZooFeatureEnabled(zooOptions, 'enrichmentGuides')) {
      return false;
    }

    // Météo : nécessite l'activation + coordonnées GPS dans ZooDetails
    if (itemKey === 'WEATHER' && !zooOptions.weatherConfig?.enabled) {
      return false;
    }

    // Training : feature flag par zoo (fail-closed)
    if ((itemKey === 'TRAINING_EXERCISES' || itemKey === 'TRAINING_DASHBOARD') && !isZooFeatureEnabled(zooOptions, 'training')) {
      return false;
    }

    // Entraînement observateurs : PARTICIPER est ouvert à tout compte connecté
    // (contrat v2 du 06/10/2026, section G). Le flag `obsTraining` / la capacité
    // `observations.training` ne règlent plus que le droit de LANCER une séance
    // (canLaunchObsTrainingSession), appliqué dans les vues, pas sur l'entrée.

    // Exceptions pour admin/superAdmin - ils ont toujours accès à certaines fonctions
    const alwaysAllowedForAdmins = ['USER_CREATION', 'ZOO_MANAGEMENT', 'USER_SETTINGS'];
    if ((userRole === 'admin' || userRole === 'superAdmin') && alwaysAllowedForAdmins.includes(itemKey)) {
      return true;
    }

    // Vérifier si c'est dans le tier d'abord
    if (!hasProductPolicy(itemKey) && !tierConfig.features.includes(itemKey)) {
      return false;
    }

    // Pour pedagoadmin, vérifier si c'est dans la liste autorisée
    if (userRole === 'pedagoadmin') {
      return roleConfig.allowed.includes(itemKey);
    }

    // Pour les autres rôles, vérifier si ce n'est pas restreint
    return !roleConfig.restricted.includes(itemKey);
  };

  // Fonction pour vérifier si un outil admin Akongo est autorisé (pour la section Administration AWM)
  const isAkongoAdminAllowed = (itemKey) => {
    if (!akongoAdminOnlyTools.includes(itemKey)) {
      return false;
    }
    // Les membres Akongo ont accès à tous les outils admin
    if (isAkongoMember) {
      return true;
    }
    // Les superAdmin sur zoo Akongo aussi
    if (currentZooId === 'akongo' && userRole === 'superAdmin') {
      return true;
    }
    return false;
  };
  
  // Ajouter les items de menu selon leur catégorie

  // Dashboard, live view, timeline et vétérinaire - vérifier d'abord s'il y a des items
  // Note: TASK_MANAGEMENT est maintenant dans la section "Organisation"
  const mainItems = [];
  if (isAllowed('DASHBOARD')) {
    mainItems.push(MENU_ITEMS.DASHBOARD);
    hasMainSectionItems = true;
  }

  // Rafiki Full Access - TEMPORAIREMENT DÉSACTIVÉ (problème de streaming SSE)
  // TODO: Réactiver quand le problème sera résolu
  // if (isAkongoMember) {
  //   mainItems.push(MENU_ITEMS.RAFIKI_FULL);
  //   hasMainSectionItems = true;
  // }

  if (isAllowed('LIVE_VIEW')) {
    mainItems.push(MENU_ITEMS.LIVE_VIEW);
    hasMainSectionItems = true;
  }
  if (isAllowed('TIMELINE')) {
    mainItems.push(MENU_ITEMS.TIMELINE);
    hasMainSectionItems = true;
  }
  // NB : la partie vétérinaire n'est plus un item plat ici — elle a sa propre section
  // dépliée « Vétérinaire » (heading + 3 groupes), ajoutée juste après.

  // N'ajouter le heading principal que s'il y a des items
  if (mainItems.length > 0) {
    menu.push({
      heading: "Akongo Animal Welfare Monitor",
    });
    menu.push(...mainItems);
    hasMainSectionItems = true;
  }

  // Section « Vétérinaire » : déjà dépliée, les 3 groupes en accès direct (chaque item
  // deep-linke /VeterinaryDashboardView/:group, chemins distincts pour l'état actif).
  // Réservée aux détenteurs du droit vétérinaire (rights.vet) + superAdmin
  // (les admins sans droit vet n'y ont pas accès) — point de vérité canAccessVetModule.
  const canSeeVetSection = canAccessVetModule({
    userRoleValue: userRole,
    userRights: parsedUserData.rights,
    akongoStaff: parsedUserData.akongoStaff === true,
  });
  if (isAllowed('VETERINARY_DASHBOARD') && canSeeVetSection) {
    menu.push({
      heading: "Vétérinaire",
      translate: "sidebar.heading.VETERINARY",
    });
    menu.push(
      { name: "Suivi clinique", icon: "fa fa-stethoscope", path: "VeterinaryDashboardView/clinical", translate: "sidebar.nav.VETERINARY_CLINICAL" },
      { name: "Pharmacie", icon: "fa fa-pills", path: "VeterinaryDashboardView/pharmacy", translate: "sidebar.nav.VETERINARY_PHARMACY" },
      { name: "Référentiel & docs", icon: "fa fa-book", path: "VeterinaryDashboardView/library", translate: "sidebar.nav.VETERINARY_LIBRARY" },
      { name: "Rafiki vétérinaire", icon: "fa fa-robot", path: "VeterinaryDashboardView/rafiki", translate: "sidebar.nav.VETERINARY_RAFIKI" }
    );
  }

  // Section « Technique » — miroir de la section vétérinaire. Réservée aux détenteurs du
  // droit technique (rights.technical) + superAdmin, ET aux parcs dont le flag beta
  // `featureFlags.technicalModule` est posé : point de vérité canAccessTechnicalModule.
  // Le droit global ouvre le module ; le rôle secteur `technicalUserIds` pilote, lui, le
  // routage des notifications et le périmètre par défaut des écrans (les deux se cumulent).
  // Phase 1 : un seul groupe. Ne pas déclarer ici les groupes des phases 2 et 4 tant que
  // leurs vues n'existent pas — un onglet vide se lit comme « rien à faire ».
  const canSeeTechnicalSection = canAccessTechnicalModule(
    {
      userRoleValue: userRole,
      userRights: parsedUserData.rights,
    },
    zooOptions
  );
  if (isAllowed('TECHNICAL_DASHBOARD') && canSeeTechnicalSection) {
    menu.push({
      heading: "Technique",
      translate: "sidebar.heading.TECHNICAL",
    });
    menu.push(
      { name: "Interventions", icon: "fa fa-wrench", path: "TechnicalDashboardView/operations", translate: "sidebar.nav.TECHNICAL_OPERATIONS" }
    );
  }

  // Section Organisation (position 2) - Gestion des tâches et objectifs
  // TASK_MANAGEMENT n'est pas dispo en discovery, OBJECTIVES_MANAGEMENT l'est
  const organisationItems = ['TASK_MANAGEMENT', 'OBJECTIVES_MANAGEMENT'];
  const allowedOrganisationItems = organisationItems.filter(item => isAllowed(item));

  // La section existe toujours : les rappels personnels (MY_REMINDERS) sont
  // disponibles pour tous les rôles et tous les tiers, au-dessus des tâches
  {
    addSection("Organisation", "sidebar.heading.ORGANISATION");
    menu.push(MENU_ITEMS.MY_REMINDERS);

    allowedOrganisationItems.forEach(item => {
      menu.push(MENU_ITEMS[item]);
    });

    // Gamification soigneurs (badges + leaderboard) — pas en discovery, et
    // activation explicite du module dans ZooDetails (comme les tournées) :
    // l'onglet n'apparaît que si zoo.gamificationConfig.enabled === true.
    if ((hasProductPolicy('GAMIFICATION') ? isAllowed('GAMIFICATION') : zooTier !== 'discovery') && zooOptions.gamificationConfig?.enabled === true) {
      menu.push(MENU_ITEMS.GAMIFICATION);
    }
  }

  // Section Accompagnement AKONGO - DÉSACTIVÉE (feature en standby)
  // if (isAkongoMember || (userRole === 'superAdmin' && !isVisitingOtherZoo)) {
  //   addSection("Accompagnement AKONGO", null);
  //   menu.push({
  //     name: "Gestion des rapports",
  //     icon: "fa fa-file-alt",
  //     path: "ReportListView",
  //     translate: "sidebar.nav.REPORT",
  //   });
  // }
  
  // Section Gestion du parc
  // Note: OBJECTIVES_MANAGEMENT est maintenant dans la section "Organisation"
  const parcItems = [
    'SECTOR_MANAGEMENT', 'TOURNEE_MANAGEMENT', 'DAILY_REPORTS', 'ENCLOSURE_MANAGEMENT', 'ANIMAL_MANAGEMENT', 'GROUP_MANAGEMENT',
    'ENRICHMENT_MANAGEMENT', 'CUSTOM_PARAMETERS_HUB', 'TRAINING_EXERCISES', 'ZIMS_COLLECTION', 'WEATHER'
  ];

  // Collecter les items autorisés d'abord
  const allowedParcItems = parcItems.filter(item => isAllowed(item));

  // N'ajouter la section que si elle contient des items
  if (allowedParcItems.length > 0) {
    addSection("Gestion du parc", "sidebar.heading.PARC_MANAGEMENT");

    allowedParcItems.forEach(item => {
      menu.push(MENU_ITEMS[item]);
    });
  }

  // Section Data analyse
  // FOCAL_SAMPLING, ENRICHMENT_ANALYSIS et SCAN_ANALYSIS visibles pour tous les non-discovery
  {
    const dataAnalyseItems = [];

    // Focal Sampling pour tous les non-discovery
    if (isAllowed('FOCAL_SAMPLING')) {
      dataAnalyseItems.push('FOCAL_SAMPLING');
    }

    // Scan Analysis pour tous les non-discovery
    if (isAllowed('SCAN_ANALYSIS')) {
      dataAnalyseItems.push('SCAN_ANALYSIS');
    }

    // Quizz Analysis pour tous les non-discovery
    if (isAllowed('QUIZZ_ANALYSIS')) {
      dataAnalyseItems.push('QUIZZ_ANALYSIS');
    }

    // Enrichment Analysis pour tous les non-discovery
    if (isAllowed('ENRICHMENT_ANALYSIS')) {
      dataAnalyseItems.push('ENRICHMENT_ANALYSIS');
    }

    // Multi-Parameter Analysis (santé + environnement + customs, TCD-style)
    if (isAllowed('MULTI_PARAMETER_ANALYSIS')) {
      dataAnalyseItems.push('MULTI_PARAMETER_ANALYSIS');
    }

    // Analyse de poids (pesées, variations, records, seuils) — dédiée, à côté du multi-paramètres
    if (isAllowed('WEIGHT_ANALYSIS')) {
      dataAnalyseItems.push('WEIGHT_ANALYSIS');
    }

    // Dashboard Training (feature flag par zoo)
    if (isAllowed('TRAINING_DASHBOARD')) {
      dataAnalyseItems.push('TRAINING_DASHBOARD');
    }

    if (dataAnalyseItems.length > 0) {
      addSection("Data analyse", "sidebar.heading.DATA_ANALYSE");

      dataAnalyseItems.forEach(item => {
        menu.push(MENU_ITEMS[item]);
      });
    }
  }

  // Section Données BEA
  const beaItems = [
    'CAMPAIGN_MANAGEMENT', 'HISTORY', 'FAST_EVALUATION', 'INDIVIDUAL_FAST_EVALUATION',
    'EVALUATION_MONITORING', 'BILAN'
  ];

  // Collecter les items autorisés d'abord
  const allowedBeaItems = beaItems.filter(item => isAllowed(item));

  // N'ajouter la section que si elle contient des items
  if (allowedBeaItems.length > 0) {
    addSection("Données BEA", "sidebar.heading.BEA_DATA");

    allowedBeaItems.forEach(item => {
      menu.push(MENU_ITEMS[item]);
    });
  }

  // Section Ressources
  // GRID_MANAGEMENT : parc Essentiel et au-dessus (pas de création ni d'import de
  // grille en Discovery), ET membres Akongo, OU admins du parc si le flag
  // `featureFlags.customGrids` est posé sur le zoo (rollout parc par parc).
  // Le tier ferme l'entrée pour TOUT LE MONDE, membres Akongo compris : un membre
  // qui parcourt un parc Discovery bascule sur un parc supérieur (ou sur le zoo
  // akongo, tier plein) pour gérer des grilles — cf. src/utils/gridAccess.js.
  // Les règles Firestore autorisent déjà l'écriture sur les grilles dont
  // ownerZooId == zoo de l'utilisateur : le menu et les vues sont les seuls verrous.
  const resourceItems = [
    'QUIZZ_MONITORING',
    'ETHO_MONITORING',
    'OBS_TRAINING',
    'ENRICHMENT_GUIDES',
  ];
  const allowedResourceItems = resourceItems.filter(item => isAllowed(item));
  // Grille vierge (retour 8 d'Amélie, 27/10/2026) : la grille officielle se
  // consulte et s'exporte depuis tout parc, à toute offre (Discovery compris) ;
  // hors du mode pédagogique, qui n'évalue pas. Placée avant l'entraînement
  // des observateurs, dont elle prend la place en tête de section en Discovery.
  if (userRole !== 'pedagoadmin') {
    const trainingIndex = allowedResourceItems.indexOf('OBS_TRAINING');
    allowedResourceItems.splice(trainingIndex === -1 ? allowedResourceItems.length : trainingIndex, 0, 'BLANK_GRID');
  }
  const gridTierAllowed = isGridManagementTierAllowed(zooTier);
  const canManageOwnGrids =
    gridTierAllowed &&
    (userRole === 'admin' || userRole === 'superAdmin') &&
    isZooFeatureEnabled(zooOptions, 'customGrids');
  if (gridTierAllowed && (isAkongoMember || canManageOwnGrids)) {
    allowedResourceItems.push('GRID_MANAGEMENT');
  }

  if (allowedResourceItems.length > 0) {
    addSection("Ressources", "sidebar.heading.RESSOURCES");

    allowedResourceItems.forEach(item => {
      menu.push(MENU_ITEMS[item]);
    });
  }

  // Section Assistance (documentation + tickets support)
  // HELP_CENTER (Documentation) est accessible à tous les utilisateurs
  const allowedAssistanceItems = [];
  allowedAssistanceItems.push('HELP_CENTER');
  if (isAllowed('SUPPORT_TICKETS')) {
    allowedAssistanceItems.push('SUPPORT_TICKETS');
  }

  if (allowedAssistanceItems.length > 0) {
    addSection("Assistance", "sidebar.heading.ASSISTANCE");

    allowedAssistanceItems.forEach(item => {
      menu.push(MENU_ITEMS[item]);
    });
  }

  // Section Mon compte
  const accountItems = ['USER_SETTINGS', 'ZOO_MANAGEMENT', 'USER_CREATION'];
  const allowedAccountItems = accountItems.filter(item => isAllowed(item));

  if (allowedAccountItems.length > 0) {
    addSection("Mon compte AWM", "sidebar.heading.MY_ACCOUNT");

    allowedAccountItems.forEach(item => {
      menu.push(MENU_ITEMS[item]);
    });
  }

  // Section Analytics AKONGO - pour les membres Akongo (sur tous les zoos) ou SuperAdmin sur zoo Akongo
  if (isAkongoMember || (currentZooId === 'akongo' && userRole === 'superAdmin')) {
    addSection("Recherche", "sidebar.heading.RESEARCH");

    if (isAkongoAdminAllowed('AKONGO_PROJECTS')) {
      menu.push(MENU_ITEMS.AKONGO_PROJECTS);
    }
    if (isAkongoAdminAllowed('BIBLIOGRAPHY')) {
      menu.push(MENU_ITEMS.BIBLIOGRAPHY);
    }

    addSection("Analytics AKONGO", "sidebar.heading.ANALYTICS_AKONGO");

    if (isAkongoAdminAllowed('DISCOVERY_ANALYTICS')) {
      menu.push(MENU_ITEMS.DISCOVERY_ANALYTICS);
    }
    if (isAkongoAdminAllowed('PAID_ACCOUNTS_ANALYTICS')) {
      menu.push(MENU_ITEMS.PAID_ACCOUNTS_ANALYTICS);
    }
    if (isAkongoAdminAllowed('PUBLIC_API_ANALYTICS')) {
      menu.push(MENU_ITEMS.PUBLIC_API_ANALYTICS);
    }
    if (isAkongoAdminAllowed('ZIMS_SYNC_DASHBOARD')) {
      menu.push(MENU_ITEMS.ZIMS_SYNC_DASHBOARD);
    }
    if (isAkongoAdminAllowed('DEEPL_STATS')) {
      menu.push(MENU_ITEMS.DEEPL_STATS);
    }
    if (isAkongoAdminAllowed('RAFIKI_STATS')) {
      menu.push(MENU_ITEMS.RAFIKI_STATS);
    }
  }

  // Section Administration AWM - pour les membres Akongo (sur tous les zoos) ou SuperAdmin sur zoo Akongo
  if (isAkongoMember || (currentZooId === 'akongo' && userRole === 'superAdmin')) {
    addSection("Administration AWM", "sidebar.heading.ADMINISTRATION");

    // Établissements et projets
    if (isAkongoAdminAllowed('ESTABLISHMENT_MANAGEMENT')) {
      menu.push(MENU_ITEMS.ESTABLISHMENT_MANAGEMENT);
    }
    if (isAkongoAdminAllowed('OFFER_MIGRATION')) {
      menu.push(MENU_ITEMS.OFFER_MIGRATION);
    }
    if (isAkongoAdminAllowed('RESEARCH_PROJECTS')) {
      menu.push(MENU_ITEMS.RESEARCH_PROJECTS);
    }
    // Suivi de temps sur les packs d'heures vendus aux parcs (interne AKONGO)
    if (isAkongoAdminAllowed('TIME_TRACKING')) {
      menu.push(MENU_ITEMS.TIME_TRACKING);
    }

    // Questionnaires
    if (isAkongoAdminAllowed('QUESTIONNAIRE_ADMIN')) {
      menu.push(MENU_ITEMS.QUESTIONNAIRE_ADMIN);
    }

    // Observations
    if (isAkongoAdminAllowed('OBSERVATION_ADMIN')) {
      menu.push(MENU_ITEMS.OBSERVATION_ADMIN);
    }

    // Traductions & cache (questionnaires + éthogrammes)
    if (isAkongoAdminAllowed('TRANSLATION_CACHE_ADMIN')) {
      menu.push(MENU_ITEMS.TRANSLATION_CACHE_ADMIN);
    }

    // Enrichissements globaux
    if (isAkongoAdminAllowed('AWM_SETTINGS')) {
      menu.push(MENU_ITEMS.AWM_SETTINGS);
    }

    // Taxons
    if (isAkongoAdminAllowed('TAXON_MANAGEMENT')) {
      menu.push(MENU_ITEMS.TAXON_MANAGEMENT);
    }

    // Tickets support admin
    if (isAkongoAdminAllowed('ADMIN_TICKETS')) {
      menu.push(MENU_ITEMS.ADMIN_TICKETS);
    }

  }
  
  console.log('MenuConfig: Final menu generated with', menu.length, 'items for tier', zooTier);
  console.log('MenuConfig: Menu structure:', menu.map(item => ({
    type: item.heading ? 'heading' : 'item',
    name: item.name || item.heading,
    path: item.path
  })));
  
  return menu.filter((item, index, items) => {
    if (item.path) return canOpenProductLocation(productScope, { pathname: `/${item.path.replace(/^\//, "")}` });
    if (!item.heading) return true;
    const nextHeading = items.findIndex((next, nextIndex) => nextIndex > index && next.heading);
    return items.slice(index + 1, nextHeading < 0 ? items.length : nextHeading).some((next) => next.path && canOpenProductLocation(productScope, { pathname: `/${next.path.replace(/^\//, "")}` }));
  });
}

// Export des configurations pour référence
export { MENU_ITEMS, ZOO_TIERS, ROLE_RESTRICTIONS };
